import { Version } from '@angular/core';

/** Current version of the Angular Component Development Kit. */
const VERSION = new Version('17.3.10');
export { VERSION };
